import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    MainSubContainer,
    FavouriteGridConatainer,
    FavoriteIconMobileContainer,
    FavoriteIconDesktopContainer,
    FavouriteIcon,
    AccountGridContainer,
    AccountNameGrid,
    AccountNumberDesktopGrid,
    MoreContainer,
    DistrictGrid,
    CityGrid,
    DitrictNameContainer,
    TerritoryNameContainer,
    AccountDetailsContainer,
    AssociatedAccountBodyContainer,
    DesktopView,
    PaginationContainerMobile,
    DesktopViewPagination,
    PaginationContainer,
    MobileView,
    AccountPaginationWrapper,
} from './associatedAccount.styled';
import { sizes } from 'src/styles/Media.styled';
import FavoriteActive from 'src/assets/images/FavoriteActive.svg';
import FavoriteInActive from 'src/assets/images/favorite-inactive.svg';
import AccountDetails from 'src/pages/more/pages/accounts/components/AccountDetails/index.jsx';
import {
    setSelectedAccount,
    getAccountDetailss,
    setFavoriteIcon,
    setAccountDetailTabAction,
} from 'src/pages/more/redux/actions';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import {
    CC_USER_ROLE,
    CSR_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const AccountsList = (props) => {
    // const [isInstantFavorite, setInstantFavorite] = useState(false);
    // const [accountInfo, setAccountInfo] = useState([]);
    // const [accountDetail, setAccountDetail] = useState(false);
    const [selectedIndex, setselectedIndex] = useState(false);
    const { t } = useTranslation();
    const [showAccountDetails, setshowAccountDetails] = useState(false);
    // const accountDetailsPopoverId = 'simple-popover';
    // const [dialogZindex, setDialogZindex] = useState(10000);
    const [associatedAccountData, setAssociatedAccountData] = useState(
        props.accountData && props.accountData.slice(0, 50)
    );
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);

    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
    };

    // useEffectWithErrorLogging(() => {
    //     if (props.accountData.length > 0) setAccountInfo(props.accountData);
    // }, []);
    // const accountData = useSelector(
    //     (state) => state.accountReducer.accountsData
    // );
    const selectedAccount = useSelector(
        (state) => state.accountReducer.selectedAccount
    );
    useEffectWithErrorLogging(() => {
        if (showAccountDetails) {
            const prevAccountId = selectedAccount
                ? selectedAccount.accountId
                : null;

            if (prevAccountId) {
                const updatedAccountIndex = props.accountData.findIndex(
                    (x) => x.accountId === prevAccountId
                );
                if (updatedAccountIndex >= 0) {
                    const updatedAccount =
                        props.accountData[updatedAccountIndex];
                    // setAccountInfo(updatedAccount);
                    dispatch(setSelectedAccount(updatedAccount));
                }
            }
        }
    }, [props.accountData]);
    // useEffectWithErrorLogging(() => {
    //     dispatch(getAccountDetailss({ accountId: selectedAccount.accountId }));
    // }, []);
    // useEffectWithErrorLogging(() => {
    //     console.log(props.accountData, 'props.accountData');
    //     if (props.accountData && props.accountData.length > 0)
    //         setAccountInfo(props.accountData);
    // }, []);
    useEffectWithErrorLogging(() => {
        const startIndex = (page + 1) * 50 - 50;
        const endIndex = startIndex + 50;
        const data =
            props.accountData && props.accountData.slice(startIndex, endIndex);
        setAssociatedAccountData(data);
    }, [page, props.accountData]);
    const openAccountDetails = (account) => {
        // setAccountDetail(account);
        dispatch(setSelectedAccount(account));
        // dispatch(setShowPopup(true));
        dispatch(
            setAccountDetailTabAction({
                selectedTabIdAccount: 'accountDetails',
            })
        );
        dispatch(getAccountDetailss({ accountId: account.accountId }));
        setshowAccountDetails(true);
    };
    const closeAccountDetails = () => {
        setshowAccountDetails(false);
    };

    // const handleFavourite = (e, account) => {
    //     setInstantFavorite(!isInstantFavorite);
    // };
    // const handleClick = () => {
    //     setShowMore(true);
    // };
    const handleClick = (value) => {
        setselectedIndex(value);
    };

    const handleFavourite = (e, account) => {
        dispatch(setFavoriteIcon(account.accountId, !account.isFavorite, true));
        // setIsFavorite(account.isFavorite);

        // dispatch(getAccountDetails());
        // setInstantFavorite(!isInstantFavorite);
    };

    return (
        <>
            {associatedAccountData === undefined ? (
                <DesktopView>
                    <div style={{ margin: '15px 0' }}>
                        {t(
                            'physicians.associatedAccount.noAssociatedAccountRelatedToThisPhysician'
                        )}
                    </div>
                </DesktopView>
            ) : (
                <>
                    <AssociatedAccountBodyContainer>
                        <MainSubContainer smalDeviceMargin={'91%'}>
                            {associatedAccountData &&
                                associatedAccountData.map((account, index) => {
                                    account.showMore =
                                        selectedIndex === index ? true : false;

                                    const initAddr =
                                        account.salesHierarchyList &&
                                        account.salesHierarchyList.slice(0, 2);
                                    const finalAddr =
                                        account.salesHierarchyList &&
                                        account.salesHierarchyList.slice(2);
                                    return (
                                        <AccountGridContainer
                                            container
                                            justifyContent={'space-between'}
                                            direction="row"
                                            key={index}
                                            onClick={() =>
                                                openAccountDetails(account)
                                            }
                                        >
                                            <AccountNameGrid
                                                item
                                                xs={12}
                                                sm={5}
                                                md={5}
                                                lg={5}
                                                xl={5}
                                                mobile={8}
                                            >
                                                <span
                                                    style={{
                                                        display:
                                                            window.innerWidth <=
                                                                sizes.mobileDevice &&
                                                            'inline-flex',
                                                    }}
                                                >
                                                    <a
                                                        style={{
                                                            marginRight: '40px',
                                                            cursor: 'pointer',
                                                        }}
                                                        // onClick={() =>
                                                        //     openAccountDetails(
                                                        //         account
                                                        //     )
                                                        // }
                                                    >
                                                        {account.accountName}
                                                    </a>
                                                    {props.employeeRole !==
                                                        CC_USER_ROLE &&
                                                        props.employeeRole !==
                                                            ITA_USER_ROLE &&
                                                        props.employeeRole !==
                                                            CSR_USER_ROLE && (
                                                            <FavoriteIconMobileContainer
                                                                value={
                                                                    account.accountId
                                                                }
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    handleFavourite(
                                                                        e,
                                                                        account
                                                                    );
                                                                    e.stopPropagation();
                                                                    // setInstantFavorite(!isInstantFavorite);
                                                                    // favoriteOrUnfavorite(false);
                                                                }}
                                                            >
                                                                <FavouriteIcon
                                                                    mobilePath={
                                                                        // isInstantFavorite
                                                                        account.isFavorite ===
                                                                        true
                                                                            ? FavoriteActive
                                                                            : FavoriteInActive
                                                                    }
                                                                />
                                                            </FavoriteIconMobileContainer>
                                                        )}
                                                </span>
                                                <AccountNumberDesktopGrid>
                                                    <span
                                                        style={{
                                                            fontSize: '14px',
                                                            letterSpacing:
                                                                '-0.11px',
                                                        }}
                                                    >
                                                        {t(
                                                            'physicians.associatedAccount.account'
                                                        )}{' '}
                                                    </span>
                                                    {accountNumberZeroTrimmer(
                                                        account.accountId
                                                    )}
                                                </AccountNumberDesktopGrid>
                                                <CityGrid>
                                                    {account.city +
                                                        ', ' +
                                                        account.state}
                                                </CityGrid>
                                            </AccountNameGrid>

                                            <DistrictGrid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={6}
                                                lg={6}
                                                xl={6}
                                                mobile={12}
                                            >
                                                {initAddr &&
                                                    initAddr.map(
                                                        (address, index) => {
                                                            return (
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'block',
                                                                    }}
                                                                    key={index}
                                                                >
                                                                    <DitrictNameContainer>
                                                                        {
                                                                            address.district
                                                                        }
                                                                        {/* {address.districtCode} */}
                                                                    </DitrictNameContainer>
                                                                    {'  •  '}

                                                                    <TerritoryNameContainer>
                                                                        {
                                                                            address.territory
                                                                        }
                                                                        {/* {address.territoryCode} */}
                                                                    </TerritoryNameContainer>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                {account.salesHierarchyList &&
                                                    account.salesHierarchyList
                                                        .length > 2 &&
                                                    account.showMore ===
                                                        false && (
                                                        <MoreContainer
                                                            onClick={(e) => {
                                                                handleClick(
                                                                    index
                                                                );
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            {`+${
                                                                account
                                                                    .salesHierarchyList
                                                                    .length - 2
                                                            }`}{' '}
                                                            {t(
                                                                'physicians.associatedAccount.more'
                                                            )}
                                                        </MoreContainer>
                                                    )}
                                                {account.showMore === true &&
                                                    finalAddr.length > 0 &&
                                                    finalAddr.map(
                                                        (address, index) => {
                                                            // const addressArray =
                                                            //     address.split(',');
                                                            return (
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'block',
                                                                    }}
                                                                    key={index}
                                                                >
                                                                    <DitrictNameContainer
                                                                    // key={index}
                                                                    // style={{
                                                                    //     display: 'block',
                                                                    // }}
                                                                    >
                                                                        {
                                                                            address.district
                                                                        }
                                                                        {/* {
                                                                address.districtCode
                                                            } */}
                                                                    </DitrictNameContainer>
                                                                    {'  •  '}

                                                                    <TerritoryNameContainer>
                                                                        {
                                                                            address.territory
                                                                        }
                                                                        {/* {
                                                                address.territoryCode
                                                            } */}
                                                                    </TerritoryNameContainer>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                            </DistrictGrid>
                                            <FavouriteGridConatainer
                                                item
                                                xs={12}
                                                sm={1}
                                                md={1}
                                                lg={1}
                                                xl={1}
                                                mobile={12}
                                            >
                                                {props.employeeRole !==
                                                    CC_USER_ROLE &&
                                                    props.employeeRole !==
                                                        ITA_USER_ROLE &&
                                                    props.employeeRole !==
                                                        CSR_USER_ROLE && (
                                                        <FavoriteIconDesktopContainer
                                                            value={
                                                                account.accountId
                                                            }
                                                            onClick={(e) => {
                                                                handleFavourite(
                                                                    e,
                                                                    account
                                                                );
                                                                e.stopPropagation();
                                                                // setInstantFavorite(!isInstantFavorite);
                                                                // favoriteOrUnfavorite(false);
                                                            }}
                                                        >
                                                            <FavouriteIcon
                                                                mobilePath={
                                                                    // isInstantFavorite
                                                                    account.isFavorite ===
                                                                    true
                                                                        ? FavoriteActive
                                                                        : FavoriteInActive
                                                                }
                                                            />
                                                        </FavoriteIconDesktopContainer>
                                                    )}
                                            </FavouriteGridConatainer>
                                        </AccountGridContainer>
                                    );
                                })}
                            {showAccountDetails && (
                                <ModalDialog
                                    // modalHeight={'509px'}
                                    // marginTop={'32%'}
                                    // overflowX={'hidden'}
                                    // maxWidth={'760px'}
                                    // handleClose={closeAccountDetails}
                                    // zIndex={dialogZindex}
                                    // // paddingBottom={'110px'}
                                    // padding={'16px 3px 16px 16px'}
                                    // isIPadPotrait={true}
                                    // afterSubmitTemplate={false}
                                    // popoverId={accountDetailsPopoverId}
                                    // showPopOver={showAccountDetails}
                                    // AnchorEl={true}
                                    // // handleClose={handleSearchClose}
                                    // top={'130px'}
                                    modalHeight={'calc(100vh - 110px)'}
                                    modalWidth={'70%'}
                                    smalModalWidth={'85%'}
                                    left={'7%'}
                                    right={'7%'}
                                    bottom={'10%'}
                                    padding={'0px'}
                                    handleClose={closeAccountDetails}
                                    isIPadPotrait={false}
                                    zIndex={'2000'}
                                    marginTop={'30%'}
                                >
                                    <AccountDetailsContainer>
                                        <AccountDetails
                                            // accountDetail={accountDetail}
                                            handleClose={closeAccountDetails}
                                            selectedAccount={selectedAccount}
                                            isFromPhysician={true}
                                            employeeRole={props.employeeRole}
                                        />
                                    </AccountDetailsContainer>
                                </ModalDialog>
                            )}
                        </MainSubContainer>
                    </AssociatedAccountBodyContainer>
                    <AccountPaginationWrapper>
                        <DesktopViewPagination className="account-pagination-wrapper">
                            <PaginationContainer>
                                <BasicPagination
                                    totalRecords={
                                        props.accountData &&
                                        props.accountData.length
                                    }
                                    recordsFetched={50}
                                    pageNumber={page}
                                    handleChange={(e) => onPageChange(e)}
                                    first={first}
                                    // recordsPerPage={pageLimit}
                                    margin="12px 0px"
                                    content={t('accounts.accountSearchBox.accountSearchResult.showingAccounts')}
                                    iPadPaginatorInfoWidth={'100%'}
                                    iPadPaginatorWidth={'100%'}
                                    // flexDirection={'column'}
                                    // textAlign={'center'}
                                    // iPadPaginatorJustifyContent={'center'}
                                />
                            </PaginationContainer>
                        </DesktopViewPagination>
                        <MobileView className="mobile-pagination-wrapper">
                            <PaginationContainerMobile padding={'0px'}>
                                <BasicPagination
                                    totalRecords={
                                        props.accountData &&
                                        props.accountData.length
                                    }
                                    recordsFetched={50}
                                    pageNumber={page}
                                    handleChange={(e) => onPageChange(e)}
                                    first={first}
                                    mobilePadding={'2% 2% 2% 2%'}
                                    content={t('accounts.accountSearchBox.accountSearchResult.showingAccounts')}
                                />
                            </PaginationContainerMobile>
                        </MobileView>
                    </AccountPaginationWrapper>
                </>
            )}
        </>
    );
};
export default AccountsList;
